import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  calculateButton: {
    display: "inline-flex",
    alignItems: "center",
    height: 42,
    minHeight: 42,
    boxSizing: "border-box",
    padding: "10px 16px",
    borderRadius: 4,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "140%",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
}));
